import type * as React from 'react'

import { clsx } from 'clsx'

import {
  Badge,
  CheckIcon,
  DropdownMenu,
  Flex,
  Text,
  type FlexProps,
} from '@buffer-mono/popcorn'

import { SCHEDULE_OPTIONS } from './constants'
import type { ScheduleOption } from './types'

import styles from './ScheduleOptionItem.module.css'

type ScheduleOptionItemProps = {
  option: ScheduleOption
  onSelectOption: (option: ScheduleOption, event: Event) => void
  isSelected: boolean
  isDefault: boolean
  onMouseEnter: () => void
  isHighlighted: boolean
}

const horizontalGap: FlexProps['gap'] = '2xs'

export const ScheduleOptionItem: React.FC<ScheduleOptionItemProps> = ({
  option,
  onSelectOption,
  isSelected,
  isDefault,
  isHighlighted,
  onMouseEnter,
}) => {
  const OptionIcon = SCHEDULE_OPTIONS[option].icon

  const className = clsx({
    [styles.scheduleOptionItem]: true,
    [styles.scheduleOptionItemHighlighted]: isHighlighted,
  })

  return (
    <>
      {SCHEDULE_OPTIONS[option].withSeparator && <DropdownMenu.Separator />}
      <DropdownMenu.Item
        className={className}
        onSelect={(event: Event): void => onSelectOption(option, event)}
        onMouseEnter={onMouseEnter}
      >
        <Flex direction="column" fullWidth>
          <Flex
            direction="row"
            gap={horizontalGap}
            align="center"
            justify="between"
            fullWidth
          >
            <Flex direction="row" gap={horizontalGap} align="center">
              <OptionIcon />
              <Text weight="medium">{SCHEDULE_OPTIONS[option].label}</Text>
              {isDefault && (
                <Badge size="xsmall" className={styles.defaultBadge}>
                  Default
                </Badge>
              )}
            </Flex>
            {isSelected && <CheckIcon size="small" />}
          </Flex>

          {SCHEDULE_OPTIONS[option].description && (
            <Text
              as="small"
              color="subtle"
              className={styles.scheduleOptionDescription}
            >
              {SCHEDULE_OPTIONS[option].description}
            </Text>
          )}
        </Flex>
      </DropdownMenu.Item>
    </>
  )
}
